import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    data: null,
    loading: false,
    error: null,
    customerResponse: null,
}

export const fetchCustomerList = createAsyncThunk(
    "fetchCustomerList",
    async (body) => {
        try {
            const response = await instance.get(`crm/customer/fetch-customers?page=${body.page}&search=${body.search}&sortOrder=${body.sortOrder}&sortField=${body.sortField}&status=${body.status}`)
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)
export const createCustomer = createAsyncThunk(
    "createCustomer",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.post("/crm/customer/create-customer", body);

            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);


export const customerStatusUpdate = createAsyncThunk(
    "customerStatusUpdate",
    async (data) => {

        try {

            const response = await instance.post(`/crm/customer/update-status`, data)
            return response?.data
            //   return{loading:"loading",response:"successfully"}
        } catch (error) {
            throw error;
        }
    }
);

export const CustomerSlice = createSlice({
    name: "CustomerSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCustomerList.pending, (state) => {
            state.loading = true;
            state.customerResponse = null;
            state.data = null;
        });
        builder.addCase(fetchCustomerList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchCustomerList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(createCustomer.pending, (state) => {
            state.loading = true;
            state.customerResponse = null;
        });
        builder.addCase(createCustomer.fulfilled, (state, action) => {
            state.loading = false;
            state.customerResponse = action.payload;
        });
        builder.addCase(createCustomer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(customerStatusUpdate.pending, (state) => {
            state.loading = true;
            state.customerResponse = null;
        });
        builder.addCase(customerStatusUpdate.fulfilled, (state, action) => {
            state.loading = false;
            state.customerResponse = action.payload;
        });
        builder.addCase(customerStatusUpdate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
    }
})

export default CustomerSlice.reducer;